import { useForm } from '@refinedev/antd';
import { Create } from '@refinedev/antd';
import { Form, Input, Select, Switch, Card, Row, Col, Alert } from 'antd';
import { t } from '../../i18n';
import { CHANNEL_OPTIONS } from './constants';

export const TrackingLinkCreate = () => {
  const { formProps, saveButtonProps } = useForm({
    resource: 'admin/tracking-links',
    redirect: 'list',
  });

  return (
    <Create
      saveButtonProps={saveButtonProps}
      title={t('trackingLinks.new') || 'Yangi marketing havola'}
    >
      <Form {...formProps} layout="vertical">
        <Row gutter={24}>
          <Col xs={24} lg={14}>
            <Card title={t('trackingLinks.basicInfo') || 'Asosiy maʼlumot'}>
              <Form.Item
                label="Nomi"
                name="name"
                rules={[
                  { required: true, message: 'Nomini kiriting' },
                  { min: 2, max: 120 },
                ]}
              >
                <Input placeholder="Masalan: Instagram reklama — may" />
              </Form.Item>

              <Form.Item
                label="Kanal"
                name="channel"
                rules={[{ required: true, message: 'Kanalni tanlang' }]}
              >
                <Select placeholder="Kanalni tanlang" options={CHANNEL_OPTIONS} />
              </Form.Item>

              <Form.Item
                label="Maqsadli URL"
                name="targetUrl"
                rules={[
                  { required: true, message: 'URL kiriting' },
                  { type: 'url', message: 'URL to\'g\'ri emas' },
                ]}
                help="Havola bosilganda foydalanuvchi bu manzilga yo'naltiriladi. App Store / Play Store / landing sahifa."
              >
                <Input placeholder="https://safaro.uz" />
              </Form.Item>

              <Form.Item
                label="Slug (ixtiyoriy)"
                name="slug"
                rules={[
                  {
                    pattern: /^[A-Za-z0-9_-]{3,32}$/,
                    message:
                      'Faqat harflar, raqamlar, - va _. 3-32 belgi oralig\'ida.',
                  },
                ]}
                help="Bo'sh qoldirsangiz avtomatik yaratiladi (masalan: Aq4xZp)"
              >
                <Input placeholder="tg-may" />
              </Form.Item>

              <Form.Item label="Izoh" name="description">
                <Input.TextArea
                  rows={2}
                  maxLength={500}
                  showCount
                  placeholder="Ichki eslatma. Foydalanuvchiga ko'rinmaydi."
                />
              </Form.Item>

              <Form.Item label="Faol" name="isActive" valuePropName="checked" initialValue={true}>
                <Switch />
              </Form.Item>
            </Card>
          </Col>

          <Col xs={24} lg={10}>
            <Card title="Qo'llanma">
              <Alert
                type="info"
                showIcon
                message="Havola qanday ishlaydi?"
                description={
                  <div>
                    <p>
                      1. Havolani yarating va har bir kanal uchun alohida nom bering.
                    </p>
                    <p>
                      2. Yaratilgandan so'ng ro'yxatda qisqa URL paydo bo'ladi
                      (masalan: <code>https://api.safaro.uz/api/v1/l/Aq4xZp</code>).
                    </p>
                    <p>
                      3. URL'ni ko'chirib oling va kanalga joylashtiring (Telegram
                      kanal, Instagram bio, SMS kampaniya, QR kod).
                    </p>
                    <p>
                      4. Har bir bosish avtomatik hisoblanadi. Statistikani havola
                      sahifasidan ko'rishingiz mumkin.
                    </p>
                  </div>
                }
              />
            </Card>
          </Col>
        </Row>
      </Form>
    </Create>
  );
};
